import { Card } from "../ui/Card";
import { Button } from "../ui/Button";
import { ArrowRight } from "lucide-react";

export function ArticleCard({ title, description, category, onClick }) {
  return (
    <Card
      style={{
        padding: 0,
        overflow: "hidden",
        cursor: onClick ? "pointer" : "default",
        transition: "border-color 0.2s, box-shadow 0.2s",
      }}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.borderColor = "rgba(26, 31, 44, 0.3)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.08)";
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.borderColor = "";
          e.currentTarget.style.boxShadow = "";
        }
      }}
      onClick={onClick}
    >
      <div style={{ padding: "20px 20px 0" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>{title}</h3>
          <span
            style={{
              fontSize: 12,
              padding: "4px 10px",
              borderRadius: 9999,
              background: "rgba(26, 31, 44, 0.1)",
              color: "#374151",
            }}
          >
            {category}
          </span>
        </div>
      </div>
      <div style={{ padding: "0 20px 20px" }}>
        <p style={{ margin: 0, fontSize: 14, color: "#6b7280", lineHeight: 1.5, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
          {description}
        </p>
        {onClick && (
          <Button $variant="ghost" style={{ marginTop: 12, padding: 0, fontSize: 14, minHeight: "auto" }}>
            Read More
            <ArrowRight style={{ marginLeft: 8, height: 16, width: 16 }} />
          </Button>
        )}
      </div>
    </Card>
  );
}
